
import { Vue, Options } from "vue-class-component";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import Print from "./modules/print.vue";
import { UpdateDeliveryController } from "@/app/ui/controllers/UpdateDeliveryController";
import { UpdateDelData } from "@/domain/entities/UpdateDelivery";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import { FlagsPermissionDelivery } from "@/feature-flags/flags-permission-delivery";

@Options({
  components: {
    EmptyState,
    Print
  },
  computed: {}
})
export default class UpdateDel extends Vue {
  mounted() {
    this.refs = this.$refs;
  }

  get ableToCreate() {
    return FlagsPermissionDelivery.update_del_create.isEnabled();
  }

  refs: any = "";

  fetchList() {
    UpdateDeliveryController.fetchList();
  }

  // loading
  get isLoading() {
    return UpdateDeliveryController.isLoading;
  }

  // filter date
  get startDate() {
    return UpdateDeliveryController.filter.startDate;
  }

  get endDate() {
    return UpdateDeliveryController.filter.endDate;
  }

  setDateRange(value: Array<any>) {
    UpdateDeliveryController.setStartDate(value[0]);
    UpdateDeliveryController.setEndDate(value[1]);
    value[0] && value[1] && this.fetchList();
  }

  // Table
  get columns() {
    return [
      {
        name: this.$t("updateDelivery.columns.no"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (_: UpdateDelData, index: number) => {
          return `<div class="overflow-ellipsis text-left">${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.totalStt"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: UpdateDelData) => {
          return `<div class="overflow-ellipsis text-left">${item.deliveryTotalStt}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.totalKoli"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: UpdateDelData) => {
          return `<div class="overflow-ellipsis text-left">${item.deliveryTotalPiece}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.driverName"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: UpdateDelData) => {
          return `<div class="overflow-ellipsis text-left">${item.deliveryDriverName}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.driverPhone"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: UpdateDelData) => {
          return `<div class="overflow-ellipsis text-left">${item.deliveryDriverPhone ??
            ""}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.deliveredBy"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: UpdateDelData) => {
          return `<div class="overflow-ellipsis text-left">${ellipsisString(
            item.deliveryDeliveredBy,
            52
          )}</div>`;
        },
        vtooltip: (item: any) =>
          item.deliveryDeliveredBy?.length > 52 ? item.deliveryDeliveredBy : ""
      },
      {
        name: this.$t("updateDelivery.columns.createdAt"),
        styleHead: "w-40 text-left",
        render: (item: UpdateDelData) => {
          return `<div class="text-black-lp-300">${formatDateWithoutTime(
            item.deliveryCreatedAt
          )}</div>
            <div class="capitalize text-gray-lp-500">${ellipsisString(
              item.deliveryCreatedBy,
              14
            )}</div>`;
        }
      },
      {
        name: this.$t("updateDelivery.columns.action"),
        key: "actionable_column",
        styleHead: "w-32 text-left",
        showButton: () => {
          return true;
        }
      }
    ];
  }

  // custom button
  customButton = {
    outline: true,
    title: "Print",
    textColor: "black-lp-300",
    color: "gray-lp-400",
    small: false,
    clickFunction: (item: any) => this.refs.print.printUpdateDel(item.id)
  };

  get pagination() {
    return UpdateDeliveryController.listData.pagination;
  }

  get listData() {
    return UpdateDeliveryController.listData.data;
  }

  // Update
  onUpdate() {
    this.$router.push("/update-delivery/update");
  }

  // handle error
  get errorType() {
    return UpdateDeliveryController.errorType;
  }
}
